import { Euler, Object3D } from 'three';
import { useSnapshot } from 'valtio';

import Character from '@cartwhl/3d/r3f/components/Character';
import { ProjectType } from '@cartwhl/common/types';

import { projectStore, sceneSettingsStore } from 'stores';
import getCharacterDataFromProject from 'utils/getCharacterDataFromProject';

export default function ActiveCharacter({
  onSceneReady,
  onCharacterLoading,
}: {
  onSceneReady?: (scene: Object3D) => void;
  onCharacterLoading?: (loading: boolean) => void;
}) {
  const { currentProject } = useSnapshot(projectStore.state);
  const {
    characterSettings: { faceExpression, skinHex, showSkeleton },
  } = useSnapshot(sceneSettingsStore.state);

  const characterData = getCharacterDataFromProject(currentProject?.data);

  if (!characterData) return null;

  const { characterID, meshPath } = characterData;

  const rotation: Euler | undefined =
    currentProject.data?.type === ProjectType.MOTION
      ? new Euler(-Math.PI / 2, 0, 0)
      : undefined;

  if (!characterID || !meshPath) return null;

  return (
    <Character
      characterID={characterID}
      meshPath={meshPath}
      rotation={rotation}
      onSceneReady={onSceneReady}
      faceExpression={faceExpression}
      skinHex={skinHex}
      showSkeleton={showSkeleton}
      onCharacterLoading={onCharacterLoading}
    />
  );
}
